import { find, chain, trimStart } from 'lodash';
import { setSitePages } from './set-site-pages';
import Wix from '../services/wix-sdk-polyfill';

export const fetchAndSetSitePages = () => dispatch =>
  Promise.all([
    new Promise(resolve => Wix.getCurrentPageId(resolve)),
    new Promise(resolve => Wix.getSiteMap(resolve)),
  ]).then(values => {
    const [currentPageId, sitePages] = values;
    const pages = chain(sitePages)
      .flatMap(page => (page.subPages ? [page, ...page.subPages] : page))
      .filter(page => page.type === 'PageLink')
      .map(page => ({ ...page, pageId: trimStart(page.pageId, '#') }))
      .value();

    const currentPage = find(pages, page => page.pageId === currentPageId) || {};
    currentPage.isCurrent = true;
    dispatch(setSitePages(pages));
  });



// WEBPACK FOOTER //
// ./app/actions/fetch-and-set-site-pages.js